namespace Portico.Models.Enterprise {
    import psgm = apigateway.models;

    export interface IPrescription {
        id: number;
        daySupply: number;
        directions: string;
        documentId: number;
        ndcId: number;
        prescriberId: number;
        quantity: number;
        refills: number;
        signed: boolean;
		writtenOn: Date;
		// signatures: Signature[];
    }

    export class Prescription implements IPrescription {
        id: number;
        daySupply: number;
        directions: string;
        documentId: number;
        ndcId: number;
        prescriberId: number;
        quantity: number;
        refills: number;
        signed: boolean;
        writtenOn: Date;
		// signatures: Signature[];

		constructor(obj?: IPrescription | any) {
            this.id = null;
            this.daySupply = null;
            this.directions = '';
            this.documentId = null;
            this.ndcId = null;
            this.prescriberId = null;
            this.quantity = null;
            this.refills = null;
            this.signed = false;
            this.writtenOn = null;
			// this.signatures = [];

            if (obj) {
                this.id = obj.id || null;
				this.daySupply = obj.daySupply || null;
				this.directions = obj.directions || '';
				this.documentId = obj.documentId || null;
				this.ndcId = obj.ndcId || null;
				this.prescriberId = obj.prescriberId || null;
				this.quantity = obj.quantity || null;
				this.refills = obj.refills || null;
				this.signed = obj.signed || false;

				if (obj.writtenOn) {
					this.writtenOn = new Date((obj.writtenOn).toString());
				}

				//if (obj.signatures) {
				//	for (const signature of obj.signatures) {
				//		this.signatures.push(new Signature(signature));
				//	}
				//}
            }
        }

        mapToEnterpriseCoordinatorPrescriptionUpsearchModel() : psgm.EnterpriseCoordinatorPrescriptionServiceModelsPrescriptionModel {
			return {
				documentId: this.documentId,
                prescriberId: this.prescriberId,
                ndcId: this.ndcId,
                writtenOn: moment(this.writtenOn),
                daySupply: this.daySupply,
                refills: this.refills,
                quantity: this.quantity,
                directions: this.directions
            } as psgm.EnterpriseCoordinatorPrescriptionServiceModelsPrescriptionModel
        }
    }
}
